const qs = require('qs');
const _ = require('lodash');

const labels = {
  department: 'Department',
  search_type: 'Search Type',
  searchType: 'Search Type',
  areas: 'Area or Postcode',
  building: 'Type of property',
  bedroom: 'Bedroom',
  minPrice: 'Min Price',
  maxPrice: 'Max Price',
};

const defaultParams = {
  department: null,
  search_type: null,
  areas: null,
  building: null,
  bedroom: null,
  minPrice: null,
  maxPrice: null,
};

const searchH1 = (props) => {
  const params = _.merge({ ...defaultParams }, props);
  const {
    bedroom = '',
    search_type,
    areas = '',
    building = '',
    minPrice = '',
    maxPrice = '',
  } = params;

  let title = '',
    minimumPrice = Number(minPrice).toLocaleString(),
    maximumPrice = Number(maxPrice).toLocaleString();

  // bedroom
  if (!_.isEmpty(bedroom)) {
    title += `${bedroom}+ bedroom`;
    if (bedroom > 1) title += `s`;
    title += ` `;
  }
  if (!_.isEmpty(building)) {
    title += `${building} `;
  } else {
    title += `property `;
  }
  if (!_.isEmpty(search_type)) {
    if (search_type === 'sales') title += `for sale `;
    else if (search_type === 'lettings') title += `to rent `;
    else title += `for sale `;
  }
  if (!_.isEmpty(areas)) {
    if (_.isString(areas)) {
      title += `in ${areas} `;
    }
    if (_.isArray(areas)) {
      title += areas.join(` and `) + ` `;
    }
  }

  if (minPrice && maxPrice) {
    title += `between £${minimumPrice} and £${maximumPrice}`;
  } else if (maxPrice) {
    title += ` under  £${maximumPrice}`;
  } else if (minPrice) {
    title += ` over £${minimumPrice}`;
  }

  return title.charAt(0).toUpperCase() + title.slice(1);
};

function fixTextCase(txt) {
  return txt
    ?.split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

const processContent = (content) => {
  let newContent = [];
  _.mapKeys(content, function (value, key) {
    let label = labels[key];
    if (!label) {
      return;
    }
    if (value) {
      newContent.push({
        id: key,
        title: label,
        param: fixTextCase(value),
      });
    }
  });
  return newContent;
};

const preprocess = (params) => {
  let data = {
    title: searchH1(params),
    content: processContent(params),
  };
  return data;
};

const preProcessSearches = (content) => {
  let data = content.map((c) => {
    if (!_.isEmpty(c)) return { ...c, ...preprocess(c.params) };
    return false;
  });

  return data;
};

export function getPathFromSearchParams(params) {
  let searchPath = `/${params.ptype === 'lettings' ? 'to-rent' : 'for-sale'}`;
  if (params.areas) {
    searchPath += `/in-${params.areas.split(' ').join('-')}`;
  }
  if (params.department) {
    searchPath += `/type-${params.department}`;
  }
  if (params.minPrice && params.maxPrice) {
    searchPath += `/between-${params.minPrice}-${params.maxPrice}`;
  } else if (params.minPrice) {
    searchPath += `/above-${params.minPrice}`;
  } else if (params.maxPrice) {
    searchPath += `/below-${params.maxPrice}`;
  }
  return searchPath;
}

export const createSearchUrl = (params, settings = {}) => {
  let pricePath = '',
    bedroomPath = '',
    pagePath = '',
    propertypath = '',
    sortPath = '',
    areaPath = '',
    layoutPath = '',
    search_typePath = '',
    departmentPath = '';

  if (params?.areas) {
    areaPath = `/in-${params.areas.replace(' ', '-')}`;
  }
  if (params?.building) {
    propertypath = `/type-${params.building}`;
  }
  if (params?.bedroom) {
    if (params?.bedroom === 0) bedroomPath = `/studio`;
    else bedroomPath = `/${params?.bedroom}-and-more-bedrooms`;
  }

  if (params.minPrice && params.maxPrice) {
    pricePath = `/between-${params.minPrice}-and-${params.maxPrice}`;
  } else if (params.maxPrice) {
    pricePath = `/under-${params.maxPrice}`;
  } else if (params.minPrice) {
    pricePath = `/over-${params.minPrice}`;
  }

  if (params.sortBy) {
    if (params.sortBy === `bedroom-asc`) sortPath = '/sortby-bedroom-asc';
    else if (params.sortBy === `bedroom-desc`) sortPath = '/sortby-bedroom-desc';
    else if (params.sortBy === `price-asc`) sortPath = '/sortby-price-asc';
  }

  if (params.page && params.page !== 1) {
    pagePath = `/page-${params.page}`;
  }

  if (params.search_type) {
    search_typePath = `/${params.search_type}`;
  }

  let status = 'for-sale';
  if (params?.search_type === 'lettings') status = 'to-rent';
  search_typePath = `/${status}`;

  if (params.layout) {
    layoutPath = `/${params.layout}`;
  }

  if (params.department !== 'residential') {
    departmentPath = `/${params.department}`;
  }

  let myUrl = `${areaPath}${propertypath}${bedroomPath}${pricePath}${sortPath}${pagePath}`;

  if ('/' === myUrl.substr(myUrl.length - 1)) myUrl = myUrl.substr(0, myUrl.length - 1);

  return `${
    process.env.GATSBY_SEARCH_BASE_URL || '/property'
  }${layoutPath}${departmentPath}${search_typePath}${myUrl}`.replace(/\/\//g, '/');
};

export { preProcessSearches };
